import {flickityLib} from '../lazy_modules';
import {OurFeedbackSvc} from '../services/OurFeedbackSvc';

export class FeedbackSlider {
    feedbackIds: string[];
    readonly flicktyPromise: ng.IPromise<any>;
    product: AnimatronProduct;
    theme: 'black' | 'white';
    feedbacks = this.feedbackIds ? this.OurFeedbackSvc.getByIds(this.feedbackIds) : this.OurFeedbackSvc.getFor(this.product);

    constructor(private $element: ng.IAugmentedJQuery,
                private $q: ng.IQService,
                private OurFeedbackSvc: OurFeedbackSvc) {
        this.flicktyPromise = $q(resolve => loadScripts([flickityLib], resolve));
    }

    $postLink() {
        this.flicktyPromise.then(() => {
            const Flickity = (window as any).Flickity;
            new Flickity(this.$element[0].firstChild, {
                cellSelector: 'feedback-slider .feedback-item',
                prevNextButtons: true,
                wrapAround: true,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: false
            });
        });
    }

    getImageUrl(image: string) {
        return `https://assets.animatron.com/images/landing/feedbacks/${image}`;
    }
}

angular.module('animatronApp.feedback').component('feedbackSlider', {
    bindings: {
        theme: '@?',
        product: '<?',
        feedbackIds: '<?'
    },
    controller: FeedbackSlider,
    templateUrl: require('feedback-slider.html')
});


// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/feedbackSlider.ts